/* unplugin-vue-components disabled */import { render } from "./ChatLoading.vue?vue&type=template&id=20a3cc06"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__